import React from "react"
import moment from "moment"
import DatePicker from "react-datepicker"

import ContentLoaderTags from "../../../common/content-loading/ContentLoaderTags"
import NotificationStatus from "../../NotificationStatus"
import { getNotificationFutureDate } from "../../util"

const calculateMinTime = (date, referenceDate) => {
    if (!referenceDate) {
        referenceDate = getNotificationFutureDate()
    }
    let isToday = date.isSame(referenceDate, "day")
    if (isToday) {
        return referenceDate
    }
    return moment().startOf("day") // set to 12:00 am today
}

const NotificationEditItemDates = ({
    expires,
    not_before,
    isFetching,
    onValueChange,
    onExpiresToggle,
}) => (
    <div className="widget">
        <div className="widget-content">
            <h3 className="first-heading">
                <i className="icon icon-headline" />
                Start date
            </h3>
            <div className="form-group">
                <DatePicker
                    name="not_before"
                    placeholder="Start date"
                    className="form-control"
                    selectsStart={true}
                    selected={not_before}
                    startDate={not_before}
                    endDate={expires}
                    onChange={onValueChange("not_before")}
                    showTimeSelect={true}
                    timeIntervals={1}
                    timeFormat="HH:mm"
                    dateFormat="LLL"
                    minDate={getNotificationFutureDate()}
                    minTime={calculateMinTime(not_before)}
                    maxTime={getNotificationFutureDate().endOf("day")}
                    locale={moment.locale()}
                />
            </div>
            <h3>
                <i className="icon icon-headline" />
                Expiry date
            </h3>
            <label>
                <input
                    type="checkbox"
                    name="active"
                    checked={!!expires}
                    onChange={onExpiresToggle}
                />{" "}
                Add an expiry date
            </label>
            {expires && (
                <div className="form-group">
                    <DatePicker
                        name="expires"
                        placeholder="Expiry date"
                        className="form-control"
                        selectsEnd={true}
                        selected={expires}
                        startDate={not_before}
                        endDate={expires}
                        onChange={onValueChange("expires")}
                        showTimeSelect={true}
                        timeIntervals={1}
                        timeFormat="HH:mm"
                        dateFormat="LLL"
                        minDate={
                            getNotificationFutureDate().isAfter(not_before)
                                ? getNotificationFutureDate()
                                : not_before
                        }
                        minTime={calculateMinTime(
                            expires,
                            (getNotificationFutureDate().isAfter(not_before)
                                ? getNotificationFutureDate()
                                : moment(not_before)
                            ).add(1, "hours")
                        )}
                        maxTime={getNotificationFutureDate().endOf("day")}
                        locale={moment.locale()}
                    />
                </div>
            )}
            <h3>
                <i className="icon icon-status" />
                Status
            </h3>
            <ContentLoaderTags isFetching={isFetching} tags={1} tagLength={20}>
                <NotificationStatus expires={expires} not_before={not_before} />
            </ContentLoaderTags>
        </div>
    </div>
)

export default NotificationEditItemDates
